export default __webpack_public_path__ + "static/media/newYorkGiants@2x.c68ff153.jpg";